import { BackgroundCircleProps } from './BackgroundCircle';

export const BackgroundCircleSvg = ({
    fill,
}: Pick<BackgroundCircleProps, 'fill'>) => (
    <svg fill="none" height={704} viewBox="0 0 784 704" width={784}>
        <path
            d="M668.433 589.082c152.814-152.814 152.814-400.574 0-553.388-152.814-152.814-400.574-152.814-553.388 0-152.813 152.814-152.813 400.574 0 553.388 152.814 152.813 400.574 152.813 553.388 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={0.5}
        />
        <path
            d="M654.501 575.149c145.119-145.119 145.119-380.403 0-525.522-145.119-145.12-380.403-145.12-525.522 0-145.12 145.119-145.12 380.403 0 525.522 145.119 145.119 380.403 145.119 525.522 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={0.656}
        />
        <path
            d="M640.568 561.216c137.424-137.424 137.424-360.233 0-497.656-137.424-137.425-360.233-137.425-497.657 0-137.424 137.424-137.424 360.232 0 497.656 137.424 137.424 360.233 137.424 497.657 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={0.813}
        />
        <path
            d="M626.635 547.283c129.729-129.729 129.729-340.062 0-469.79-129.729-129.73-340.061-129.73-469.79 0-129.73 129.728-129.73 340.061 0 469.79 129.729 129.729 340.061 129.729 469.79 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={0.969}
        />
        <path
            d="M612.701 533.35c122.034-122.034 122.034-319.891 0-441.925-122.034-122.034-319.891-122.034-441.925 0-122.034 122.034-122.034 319.891 0 441.925 122.034 122.035 319.891 122.035 441.925 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={1.125}
        />
        <path
            d="M598.769 519.417c114.339-114.339 114.339-299.72 0-414.059-114.339-114.34-299.72-114.34-414.06 0-114.339 114.339-114.339 299.72 0 414.059 114.34 114.34 299.721 114.34 414.06 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={1.281}
        />
        <path
            d="M584.64 505.288c106.536-106.536 106.536-279.265 0-385.801-106.537-106.536-279.266-106.536-385.802 0s-106.536 279.265 0 385.801c106.536 106.537 279.265 106.537 385.802 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={1.438}
        />
        <path
            d="M570.707 491.356c98.842-98.842 98.842-259.095 0-357.936-98.841-98.841-259.094-98.841-357.935 0-98.842 98.841-98.842 259.094 0 357.936 98.841 98.841 259.094 98.841 357.935 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={1.594}
        />
        <path
            d="M556.773 477.423c91.147-91.146 91.147-238.924 0-330.07-91.146-91.147-238.924-91.147-330.07 0-91.146 91.146-91.146 238.923 0 330.07 91.146 91.146 238.924 91.146 330.07 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={1.75}
        />
        <path
            d="M542.842 463.49c83.451-83.451 83.451-218.753 0-302.205-83.452-83.451-218.753-83.451-302.205 0-83.451 83.452-83.451 218.753 0 302.205 83.452 83.451 218.753 83.451 302.205 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={1.906}
        />
        <path
            d="M528.91 449.557c75.756-75.756 75.756-198.582 0-274.339-75.757-75.756-198.583-75.756-274.339 0-75.757 75.757-75.757 198.583 0 274.339 75.756 75.757 198.582 75.757 274.339 0Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={2.063}
        />
        <path
            d="M562.874 345.587c18.337-94.493-43.401-185.96-137.894-204.296-94.493-18.337-185.96 43.4-204.296 137.894-18.337 94.493 43.4 185.959 137.894 204.296 94.493 18.337 185.96-43.401 204.296-137.894Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={2.219}
        />
        <path
            d="M544.265 337.418c13.822-84.245-43.268-163.744-127.514-177.566-84.245-13.822-163.744 43.268-177.566 127.513-13.822 84.246 43.268 163.745 127.513 177.567 84.246 13.822 163.745-43.268 177.567-127.514Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={2.375}
        />
        <path
            d="M525.322 330.809c10.205-73.79-41.34-141.881-115.13-152.087-73.79-10.205-141.882 41.341-152.087 115.131-10.205 73.79 41.341 141.881 115.13 152.086 73.79 10.206 141.882-41.34 152.087-115.13Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={2.531}
        />
        <path
            d="M506.154 325.721c7.334-63.182-37.94-120.346-101.121-127.68-63.182-7.334-120.346 37.94-127.68 101.121-7.334 63.182 37.939 120.346 101.121 127.68 63.181 7.334 120.346-37.939 127.68-101.121Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={2.688}
        />
        <path
            d="M486.791 321.523c5.072-52.483-33.362-99.14-85.845-104.212-52.483-5.072-99.141 33.362-104.213 85.845-5.071 52.483 33.363 99.141 85.846 104.213 52.483 5.072 99.14-33.363 104.212-85.846Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={2.844}
        />
        <path
            d="M467.252 318.47c3.321-41.71-27.8-78.213-69.509-81.534-41.709-3.32-78.213 27.8-81.534 69.509-3.32 41.71 27.8 78.214 69.51 81.534 41.709 3.32 78.213-27.8 81.533-69.509Z"
            opacity={0.8}
            stroke={fill || '#EAEAEA'}
            strokeMiterlimit={10}
            strokeWidth={3}
        />
    </svg>
);
